import { HomePageItem } from '../../../components/HomePage/HomePage'
import { getResourceAddress } from './getResourceAddress'

export const getFacts = async (
    windowOrigin: string
): Promise<HomePageItem[]> => {
    const resourceAddress = getResourceAddress(windowOrigin)

    const result = await fetch(
        `${resourceAddress}api/v1/facts/random?count=8`,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        }
    )

    return await result.json()
}